"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChartInitialState = void 0;
const idle_state_1 = require("./idle-state");
const default_interaction_shared_state_1 = require("../default-interaction-shared-state");
/**
 * @public
 * Provides user interaction state machine initial state.
 */
function getChartInitialState(options, stateProviders) {
    return new idle_state_1.IdleState(null, options, stateProviders, new default_interaction_shared_state_1.DefaultInteractionSharedState(stateProviders));
}
exports.getChartInitialState = getChartInitialState;
//# sourceMappingURL=get-chart-initial-state.js.map